import { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";

export const organisationNavigation: NiceNavigationItem[] = [
    {
        id: "organisation",
        title: "navigation.organisations",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:building-1",
        link: "/dashboard/organisation"
    }
];
